<template>
  <div>
    <span>{{ country }}</span>
  </div>
</template>

<script>
export default {
  name: 'CellRendererCountry',
  computed: {
    country () {
      const data = this.params.data.country
          if (data == 1)
            return('Netherlands');
          else if (data == 2)
            return('United States');
          else if (data == 3)
            return('Ukriane')
          else
          return ('')
    }
  }
}
</script>
